exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-view-wrapper .tags-view-item .el-icon-close{width:0.08333rem;height:0.08333rem;vertical-align:0.01042rem;border-radius:50%;text-align:center;transition:all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);transform-origin:100% 50%}.tags-view-wrapper .tags-view-item .el-icon-close:before{transform:scale(0.6);display:inline-block;vertical-align:-0.01563rem}.tags-view-wrapper .tags-view-item .el-icon-close:hover{background-color:#b4bccc;color:#fff}\n", ""]);

// exports
